function GetSessionProperties() {
}

module.exports = GetSessionProperties;



//////////////////
// WEBPACK FOOTER
// ./~/diffusion/src/~/services/control/get-session-properties.js
// module id = 478
// module chunks = 1